export default __webpack_public_path__ + "static/media/face.e4971bf1.jpg";